"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const autobind_decorator_1 = require("autobind-decorator");
const React = require("react");
const lodash_1 = require("lodash");
const react_bootstrap_1 = require("react-bootstrap");
const TitleComponent_1 = require("./TitleComponent");
let SelectComponent = class SelectComponent extends React.Component {
    constructor() {
        super(...arguments);
        this.select = (field, eventKey) => {
            this.props.modelChanged(field, eventKey);
        };
    }
    render() {
        const hideLabel = this.props.field.style && this.props.field.style.hideLabel;
        if (!this.props.field.title && !hideLabel) {
            console.error("Did you forget to add a \"title\" in the select field. Possible culprit: ", this.props.field);
        }
        let optionsData = [];
        if (this.props.field.foreign.transform) {
            if (typeof this.props.field.foreign.transform === "function") {
                optionsData = this.props.field.foreign.transform(this.props.field.foreign.modelName, this.props.currentModel, this.props.additionalModels, this.props.parentModel);
            }
            else {
                console.error("Did you forget to add \"function\" in the transform field. Function should return an array. Possible culprit: ", this.props.field);
            }
        }
        else {
            optionsData = lodash_1.isEmpty(this.props.field.foreign.orderby)
                ? this.props.additionalModels[this.props.field.foreign.modelName]
                : lodash_1.sortBy(this.props.additionalModels[this.props.field.foreign.modelName], (doc) => lodash_1.trim(doc[this.props.field.foreign.orderby].toLowerCase()));
        }
        let foreignTitle = !hideLabel ? "Choose " + this.props.field.title : "Choose";
        if (this.props.field.foreign) {
            if (!this.props.field.foreign.key && !this.props.field.foreign.keys) {
                console.error(`Did you forget to add a "key(s)" field in foreign. Possible culprit: ${this.props.field}`);
            }
            if (this.props.field.foreign.key && this.props.field.foreign.keys) {
                console.error(`ambiguous use of "key" and "keys", use any one`);
            }
            if (!this.props.field.foreign.title) {
                console.error(`Did you forget to add a "title" field in foreign . Possible culprit: ${this.props.field}`);
            }
            if (!lodash_1.isNil(this.props.currentModel) && !(lodash_1.isObject(this.props.currentModel) && lodash_1.isEmpty(this.props.currentModel))) {
                const foreignDoc = lodash_1.find(optionsData, (doc) => {
                    if (this.props.field.foreign.keys) {
                        return this.props.field.foreign.keys.every((key) => doc[key] === this.props.currentModel[key]);
                    }
                    if (this.props.field.valueType === "object") {
                        return doc.id === this.props.currentModel.id;
                    }
                    if (this.props.field.foreign.key) {
                        return doc[this.props.field.foreign.key] === this.props.currentModel;
                    }
                    console.error(`Did you forget to add a "key(s)" field in foreign . Possible culprit: ${this.props.field}`);
                });
                if (lodash_1.isEmpty(foreignDoc)) {
                    foreignTitle = this.props.currentModel + " Bad Value";
                }
                else if (this.props.field.foreign.titleTransform && typeof this.props.field.foreign.titleTransform === "function") {
                    foreignTitle = this.props.field.foreign.titleTransform(foreignDoc);
                }
                else {
                    foreignTitle = foreignDoc[this.props.field.foreign.title];
                }
            }
        }
        else {
            console.error("Did you forget to add a \"foreign\" field with a type: \"select\". Possible culprit: ", this.props.field);
        }
        return React.createElement("div", null,
            this.props.showTitle && !lodash_1.isEmpty(this.props.field.title) && !hideLabel &&
                React.createElement("div", null,
                    React.createElement(TitleComponent_1.TitleComponent, { field: this.props.field }),
                    React.createElement("br", null)),
            React.createElement(react_bootstrap_1.DropdownButton, { bsSize: "small", style: { width: "auto" }, id: this.props.field.field + "_dropdown", title: foreignTitle, disabled: this.props.readonly },
                React.createElement(react_bootstrap_1.MenuItem, { onSelect: () => this.select(this.props.field, undefined) }, "-Select-"),
                lodash_1.map(optionsData, ((doc, index) => {
                    let eventKey = doc;
                    if (this.props.field.valueType === "object") {
                        eventKey = doc;
                    }
                    else if (this.props.field.foreign.keys) {
                        eventKey = {};
                        for (const key of this.props.field.foreign.keys) {
                            eventKey[key] = doc[key];
                        }
                    }
                    else if (this.props.field.foreign.key) {
                        eventKey = doc[this.props.field.foreign.key];
                    }
                    else {
                        console.error(`Did you forget to add a "key(s)" field in foreign . Possible culprit: ${this.props.field}`);
                    }
                    return React.createElement(react_bootstrap_1.MenuItem, { onSelect: (eventKey) => this.select(this.props.field, eventKey), key: index, eventKey: eventKey }, this.props.field.foreign.titleTransform ? this.props.field.foreign.titleTransform(doc) : doc[this.props.field.foreign.title]);
                }))));
    }
};
SelectComponent = __decorate([
    autobind_decorator_1.default
], SelectComponent);
exports.SelectComponent = SelectComponent;
//# sourceMappingURL=SelectComponent.js.map